import {
  normalizeCellRange,
  tableCellStyles,
  type CellRange,
  type CellStyle,
  type TableMeta,
} from "../shared/table-tools";

export const tableStyleDefaults = {
  fontFamily: "Arial",
  fontSize: 14,
  textColor: "#25343b",
  fill: "#ffffff",
  border: "#d6dad3",
  align: "left",
  bold: false,
  italic: false,
} as const satisfies Required<CellStyle>;

export type MixedCellStyle = {
  [K in keyof Required<CellStyle>]: Required<CellStyle>[K] | null;
};

/** A null field means that the selected cells have different effective values. */
export function selectedTableStyle(
  meta: TableMeta,
  rows: string[][],
  requested: CellRange,
): MixedCellStyle {
  const range = normalizeCellRange(requested, rows);
  const styles = tableCellStyles(meta);
  const keys = Object.keys(tableStyleDefaults) as (keyof Required<CellStyle>)[];
  let first: MixedCellStyle | null = null;
  for (let row = range.startRow; row <= range.endRow; row++) {
    for (let column = range.startColumn; column <= range.endColumn; column++) {
      const cell = styles[`${row}:${column}`] ?? {};
      if (!first) {
        first = Object.fromEntries(
          keys.map((key) => [key, cell[key] ?? tableStyleDefaults[key]]),
        ) as MixedCellStyle;
        continue;
      }
      for (const key of keys) {
        const value = cell[key] ?? tableStyleDefaults[key];
        if (first[key] !== value)
          (first as Record<string, unknown>)[key] = null;
      }
    }
  }
  return first ?? { ...tableStyleDefaults };
}
